export const getShortId = (purchaseOrder) => {
	if (purchaseOrder.internalId) {
		return `${purchaseOrder.internalId}`
	} else {
		return `PO-${purchaseOrder.shortId}`
	}
}
